import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-curtain', 'showLess', 'Rodyti mažiau');
Labels.set('ui-curtain', 'showMore', 'Rodyti daugiau');
Labels.set('ui-curtain', 'completedStep', 'Užbaigtas žingsnis');
